// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { MANUFACTURER_ATTRIBUTE_NAME } from "@ces/XDL/constants";
import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";

const manufacturerAttributeName = MANUFACTURER_ATTRIBUTE_NAME.trim().toLowerCase();
export const isManufacturerAttribute = (attributeType: AttributeTypeModel): boolean => {
    return (
        attributeType.name?.trim().toLowerCase() === manufacturerAttributeName ||
        attributeType.label?.trim().toLowerCase() === manufacturerAttributeName
    );
};

export const getManufacturerDisplayValue = (attributeTypes: AttributeTypeModel[]): string => {
    const attributeType = attributeTypes.find(isManufacturerAttribute);
    if (!attributeType) {
        return "";
    }
    return (attributeType.attributeValues ?? []).map(attributeValue => attributeValue.valueDisplay).join(", ");
};
